import { useState } from "react";

const useModal = <T>() => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState<T>();

  const openModal = (data?: T) => {
    setIsModalOpen(true);
    if (data) {
      setModalData(data);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalData(undefined);
  };

  return {
    modalData,
    isModalOpen,
    openModal,
    closeModal,
    setModalData,
  };
};

export default useModal;
